import { render, staticRenderFns } from "./TradesmanThumbCommentList.vue?vue&type=template&id=ba9ccfb2&scoped=true&"
import script from "./TradesmanThumbCommentList.vue?vue&type=script&lang=js&"
export * from "./TradesmanThumbCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ccfb2",
  null
  
)

export default component.exports